<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<ng-template #checkListPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelCheckListPopup()" mat-button>
            <i style="font-size: 23px;color: white;" class="fa">&#xf00d;</i>
        </button>

        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{ checkList.stageName }}&nbsp; CheckList</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div *ngIf="!isProcessing" style="margin: 10px;">
            <div class="row">
                <div class="col-md-6">
                    <div>
                        <label for="template"> Template :</label>
                    </div>
                    <div>
                        <mat-select [(ngModel)]="template" placeholder="Select" (closed)="templateSearchText = ''"
                            (click)="focusSearch('template-search')" (keydown.enter)="focusSearch('template-search')">
                            <input matInput type="template-search" [(ngModel)]="templateSearchText"
                                class="dropdownsearchstyle" placeholder="Search">
                            <mat-option *ngFor="let item of templateDropDown | assessmentSearch : templateSearchText"
                                [value]="item.valueExp" (onSelectionChange)="onTemplateSelect($event, item)">
                                {{ item.displayExp }}
                            </mat-option>
                        </mat-select>
                    </div>
                </div>
                <ng-container *ngIf="template">
                    <div class="d-flex justify-content-center gap-3 mx-3 button-continer" mat-dialog-actions>
                        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                            (click)="create()" (keydown.enter)="create()" *ngIf="!checkListFields.length">
                            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px"
                                alt="add new" />
                            <span class="reload_text text-white">Add CheckList(s)</span>
                        </div>
                        <div *ngIf="isWarning"
                            style="text-align: center; color: red; font-weight: 500; font-style: oblique;">
                            Template name has been changed.<br>
                            This will delete checklist from previous template. Do you want to update?
                        </div>
                    </div>
                </ng-container>
            </div>

            <div class="form-continer" style="max-height: 450px !important;">
                <div *ngIf="checkListFields.length && !isProcessing && !isWarning">
                    <ng-container *ngFor="let field of checkListFields; let i = index;">
                        <div class="row" style="margin-top: 1px; display: flex; align-items: center;">
                            <div class="col-md-4">
                                <label id="category-name" for="email">{{ i + 1 }}.&nbsp;{{ field.fieldName }}</label>
                            </div>

                            <div class="col-md-4">
                                <div>
                                    <label id="analytical-lab-investigation" for="email">
                                        Response
                                    </label>
                                    <span class="mandatory-symbol">*</span>
                                </div>
                                <ng-container [ngSwitch]="field.fieldTypeCode">
                                    <!-- Text Field -->
                                    <input *ngSwitchCase="'Text Field'" class="form-control"
                                        [(ngModel)]="field.response" (ngModelChange)="changeDetected()">

                                    <!-- Date Field -->
                                    <input *ngSwitchCase="'Date Field'" type="text"
                                        class="form-control data-picker-continer" bsDatepicker
                                        (bsValueChange)="changeDetected()" [bsConfig]="commonDateConfig"
                                        [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.response">

                                    <!-- Large Text -->
                                    <textarea *ngSwitchCase="'Large Text'" class="input-filed-textarea" rows="4"
                                        [(ngModel)]="field.response" (ngModelChange)="changeDetected()"></textarea>

                                    <!-- Drop Down -->
                                    <mat-select *ngSwitchCase="'Drop Down'" [(ngModel)]="field.response"
                                        placeholder="Select" (closed)="dropDownSearchText=''"
                                        (selectionChange)="changeDetected()" (click)="focusSearch('search')"
                                        (keydown.enter)="focusSearch('search')">
                                        <input matInput type="search" [(ngModel)]="dropDownSearchText"
                                            class="dropdownsearchstyle" placeholder="Search">
                                        <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                                        <mat-option
                                            *ngFor="let item of field.fieldValues | assessmentSearch : dropDownSearchText"
                                            [value]="item">{{ item }}</mat-option>
                                    </mat-select>

                                    <!-- Multiselect Drop Down -->
                                    <mat-select *ngSwitchCase="'Multiselect Drop Down'" multiple #multiselect
                                        [attr.data-field-id]="field.fieldId" [(ngModel)]="field.dd" placeholder="Select"
                                        (selectionChange)="changeDetected()" (closed)="dropDownSearchText=''"
                                        (click)="focusSearch('multi-search')"
                                        (keydown.enter)="focusSearch('multi-search')" [matTooltip]="field.dd"
                                        matTooltipPosition="below" [matTooltipShowDelay]="300"
                                        [matTooltipHideDelay]="100" matTooltipClass="custom-tooltip">
                                        <input matInput type="multi-search" [(ngModel)]="dropDownSearchText"
                                            placeholder="Search" class="dropdownsearchstyle">
                                        <div class="select-all">
                                            <mat-checkbox [(ngModel)]="field.multiSelection"
                                                (change)="toggleAllSelection('multiselect', field);">Select
                                                All</mat-checkbox>
                                        </div>
                                        <mat-option (onSelectionChange)="onMultiSelect($event, field);"
                                            *ngFor=" let q of field.fieldValues | assessmentSearch : dropDownSearchText"
                                            [value]="q">
                                            {{ q }}
                                        </mat-option>
                                    </mat-select>

                                    <!-- Vertical Radio Button -->
                                    <mat-radio-group *ngSwitchCase="'Vertical Radio Button'"
                                        [(ngModel)]="field.response" class="d-flex flex-column"
                                        matTooltipPosition="below" (change)="changeDetected()">
                                        <mat-radio-button *ngFor="let val of field.fieldValues" [value]="val">
                                            {{ val }}
                                        </mat-radio-button>
                                    </mat-radio-group>

                                    <!-- Horizontal Radio Button -->
                                    <ng-container *ngSwitchCase="'Horizontal Radio Button'">
                                        <mat-radio-group [(ngModel)]="field.response" (change)="changeDetected()"
                                            class="d-flex flex-wrap" matTooltipPosition="below">
                                            <mat-radio-button class="me-3 mb-2" *ngFor="let val of field.fieldValues"
                                                [value]="val">
                                                {{ val }}
                                            </mat-radio-button>
                                        </mat-radio-group>
                                    </ng-container>

                                    <!-- Vertical Checkbox Button -->
                                    <ng-container *ngSwitchCase="'Vertical Checkbox Button'">
                                        <section *ngFor="let val of field.fieldValues" class="d-flex flex-column">
                                            <mat-checkbox
                                                (change)="onCheckboxChange($event, val, field); changeDetected();"
                                                [checked]="field.dd.indexOf(val) != -1">
                                                {{ val }}
                                            </mat-checkbox>
                                        </section>
                                    </ng-container>

                                    <!-- Horizontal Checkbox Button -->
                                    <ng-container *ngSwitchCase="'Horizontal Checkbox Button'"
                                        style="align-items: center;">
                                        <section *ngFor="let val of field.fieldValues" class="d-inline-flex">
                                            <mat-checkbox [checked]="field.dd.indexOf(val) != -1"
                                                (change)="onCheckboxChange($event, val, field); changeDetected();">
                                                {{ val }}
                                            </mat-checkbox>
                                        </section>
                                    </ng-container>
                                </ng-container>
                            </div>

                            <div class="col-md-4">
                                <div>
                                    <label id="justification" for="email">
                                        Justification
                                    </label>
                                    <span class="mandatory-symbol">*</span>
                                </div>
                                <textarea class="input-filed-textarea" rows="4" [(ngModel)]="field.justification"
                                    (ngModelChange)="changeDetected()"></textarea>
                            </div>

                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="d-flex justify-content-center gap-3 mx-3 button-continer" mat-dialog-actions *ngIf="template">
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="update()"
                    (keydown.enter)="update()" *ngIf="checkListFields.length">
                    <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
                    <span class="reload_text text-white">Update</span>
                </div>
                <button mat-stroked-button class="cancelButton" (click)="cancelCheckListPopup()">
                    <i class="fa fa-close"></i> Cancel
                </button>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #resultPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelResultPopup()" mat-button>
            <i class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> Field Result(s) </label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="table-container" style="margin: 10px;">
            <table style="max-height: 65vh;">
                <thead>
                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Field</span>
                        </div>
                    </th>

                    <th class="grid-header-container"
                        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
                            <span>Result</span>
                        </div>
                    </th>

                    <th id="menu" class="sticky-col first-col"></th>
                </thead>
                <tbody>
                    <tr class="data-row-container" *ngFor="let r of responses; let idx = index;">
                        <td class="row-data">
                            <!--Is commented for later debugging {{isAdding}} -->
                            {{ isAdding ? r.field.fieldName : r.field.fieldName }}
                        </td>
                        <td class="row-data"
                            [ngStyle]=" r.response.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
                            {{ r.response.result }}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelResultPopup()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>